export function getFirstIndex(items: any[] | undefined): any | undefined {
  return items?.length ? items[0] : undefined;
}
